import { useRequestHeader, useRuntimeConfig } from '#imports';

export const useOrganizationDomain = (): null | string => {
  const config = useRuntimeConfig();

  const enforcedDomain = config.public.localEnforcedOrganizationDomain;

  if (enforcedDomain) {
    return enforcedDomain === 'NONE' ? null : enforcedDomain;
  }

  const host = useRequestHeader('host') ?? globalThis.location.host;
  const normalizedHost = host.startsWith('www.') ? host.slice(4) : host;

  return normalizedHost === config.public.appDomain ? null : normalizedHost;
};
